<template>
<div id="representantes" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Nuevo Proceso DVC" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>

                            <v-btn fab dark x-small color="secondary" @click.native="openModal(1)" title="Nuevo DVC" v-tippy>
                                <v-icon dark>present_to_all</v-icon>
                            </v-btn>

                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" @click="downloadLayout('Plantillas/dvc_cove_template.xlsx')" v-tippy>
                                <v-icon dark>receipt</v-icon>
                            </v-btn>

                            <v-btn fab dark x-small color="green darken-2" title="Información de Ayuda" @click="downloadLayout('Plantillas/template_ayuda.xlsx')" v-tippy>
                                <v-icon dark>info</v-icon>
                            </v-btn>
                        </v-speed-dial>

                    </v-card-actions>

                    <v-dialog v-model="modal" max-width="45%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Nuevo DVC</strong>
                                    </span>
                                </v-card>                                
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md text-xs-center>
                                    <v-form ref="form" lazy-validation>
                                        <v-card-text>
                                            <v-container grid-list-md text-xs-center @keyup.enter="send()" >
                                                <v-layout row wrap>
                                                    <v-flex s6 m6 l6>
                                                        <v-text-field label="Nombre de Proceso" type="text" v-model="nombre_proceso" maxlength="200" hint="Ingrese el nombre del proceso para poder cargar la plantilla." persistent-hint></v-text-field>
                                                    </v-flex>
                                                </v-layout>

                                                
                                                <v-row wrap>
                                                    <v-col>
                                                        <span class="v-label theme--light font-weight-bold left" >Primero seleccione archivos a adjuntar, si es que aplica  </span>
                                                    </v-col>
                                                </v-row>
                                                <v-row wrap>
                                                    <v-col>
                                                        <v-text-field label="Seleccione archivos adjuntos" v-model='archivos_adjuntos_nombres' @click='pickFile' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                        <input type="file" style="display: none" ref="file_input" accept=".pdf" @change="onFilePicked" multiple>
                                                    </v-col>
                                                </v-row>
                                                <br>
                                                <v-row wrap>
                                                    <v-col>
                                                        <span class="v-label theme--light font-weight-bold left" >Finalmente seleccione la Plantilla con información del DVC</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row wrap>
                                                    <v-col>
                                                        <!-- firstRow 5, significa que los datos empiezan en el renglón 5-->
                                                        <!-- headerRow 4, significa que los enzabezados están en el renglón 4-->
                                                        <upload-excel-component v-if="nombre_proceso!=''" :on-success="handleSuccess" :before-upload="beforeUpload" :headerRow=4 :firstRow=5 :headersExcel="headersExcel" />
                                                    </v-col>
                                                </v-row>

                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                </v-container>
                            </v-card-text>                            
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-refresh-button :funcion="cargar" />
                            <v-client-table ref="principalTable" :data="registros.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="facturas" slot-scope="props">
                                    <v-chip color="blue" label outlined x-small @click="verFacturas(props.row)">
                                        Ver {{ props.row.request.length }} Facturas
                                    </v-chip>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" open-on-hover v-if="(props.row.estatus == 'Creado' || props.row.estatus == 'Error' || props.row.filename != null)" >
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >
                                                <v-icon v-if="fab" >mdi-close</v-icon>
                                                <v-icon v-else>reorder</v-icon>
                                            </v-btn>
                                        </template>                                        
                                        <v-btn x-small fab dark color="purple" @click.native="downloadFile(props.row._id)" title="Layout Cargado" v-tippy>
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="red"  v-if="props.row.estatus == 'Creado'" @click.native="cargarDetalleFactura(props.row)" title="Vista Previa PDF" v-tippy>
                                            <v-icon>mdi-file-pdf-box</v-icon>
                                        </v-btn>                                        
                                        <v-btn x-small fab dark color="blue" v-if="(props.row.estatus == 'Creado' || props.row.estatus == 'Error')" @click.native="transmitir(props.row._id)" title="Transmitir DVC" v-tippy>
                                            <v-icon>send</v-icon>
                                        </v-btn>
                                        <!--v-btn x-small fab dark color="pink" v-if="props.row.estatus == 'Creado'" @click.native="deleteRegistro(props.row._id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn-->
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                        </div>
                        <!--div>
                            <v-card class="default " style="font-size:11px;" >
                                <span class="" >
                                    <strong>ESTATUS<br />
                                        Sin transmitir:</strong> DVC sin transmitir.<br />
                                    <strong>Transmitido correctamente:</strong> Todos los DVCs transmitidos.<br />
                                    <strong>Transmitido con errores:</strong> Algunos DVCs transmitidos con error.<br />
                                </span>
                            </v-card>
                        </div-->
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="modalPdfCove" max-width="70%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modalPdfCove = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Vista Previa de DVC Sin Transmitir</strong>
                    </span>
                </v-card>                            
            </v-card-title>     
            <v-card-actions>
                <v-spacer></v-spacer>                                
                <!--v-btn small outlined color="red" @click="downloadVistaPrevia(idCoveVistaPrevia)" title="Exportar a PDF" >
                    <v-icon>mdi-file-pdf-box</v-icon>Exportar a PDF
                </v-btn--> 
                <v-btn small outlined @click.native="modalPdfCove = false" >
                    <v-icon>cancel</v-icon> Cerrar
                </v-btn>
            </v-card-actions>            
            <v-card-text>
                
                <v-container v-if="detalle_factura.length > 0" id="pdfCoves" >
                        <span :id="detalle.numero_factura" class="manual"  v-for="(detalle, index) in detalle_factura" :key="'factura'+index" >
                            <span v-if="index>0" style="page-break-after: always;" ></span>  
                            <img v-show="showImages" src='/static/logo_negro.png' style='width:20%' id="imageHeader" >                                                                                
                            <h2 class="titulo-principal" ><center>Comprobante de Valor Electrónico</center></h2>
                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p><b style="font-weight: bold;" >Datos del DVC</b> {{ detalle.numero_factura }}</p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td colspan="2" >Tipo de operación</td>
                                    <td colspan="2" >Relación de facturas</td>
                                    <td colspan="2" >No. de factura</td>
                                </tr>
                                <tr>
                                    <td colspan="2" >{{ detalle.tipo_operacion!=undefined ?
                                            (detalle.tipo_operacion=='TOCE.IMP'?'Importación':'Exportación') 
                                            : ""
                                          }}</td>
                                    <td colspan="2" >{{ detalle.relacion_facturas=="1" ? "CON RELACION DE FACTURAS" : "SIN RELACION DE FACTURAS" }}</td>
                                    <td colspan="2" >{{ detalle.numero_factura }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Tipo de figura</td>
                                    <td colspan="3" >Fecha Exp.</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.tipo_figura!=undefined ?
                                        (detalle.tipo_figura.toString() == "4"?'Exportador':'Importador')
                                        : ""
                                         }}</td>
                                    <td colspan="3" >{{ detalle.fecha_expedicion }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="6" >Observaciones</td>
                                </tr>
                                <tr>
                                    <td colspan="6" >{{ detalle.observaciones }}</td>
                                </tr>
                            </table>
                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>RFC con permisos de consulta</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>RFC de consulta</td>
                                    <td>Nombre o Razón social</td>
                                </tr>
                                <tr v-for="(consulta, index) in detalle.usuarios_consulta" :v-key="index">
                                    <td>{{ consulta.username }}</td>
                                    <td>{{ nombresRfcConsulta[consulta.username] }}</td>
                                </tr>
                            </table>
                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Número de patente aduanal</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>Número autorización aduanal</td>
                                </tr>
                                <tr>
                                    <td>{{ detalle.personas[0].patente}}</td>
                                </tr>
                            </table>

                            <!-- Datos_factura Generales Factura -->                            
                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Datos de la factura</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>Numero Factura</td>
                                    <td>Subdivisión</td>
                                    <td>Certificado de origen</td>
                                    <td>No. de exportador autorizado</td>
                                </tr>
                                <tr>                                        
                                    <td>{{ detalle.numero_factura }}</td>                                                                            
                                    <td>{{ detalle.subdivision != undefined?
                                            (detalle.subdivision.toString()=='0'?'Sin Subdivisión':
                                            detalle.subdivision)
                                            : ''
                                            }}</td>
                                    <td>{{ detalle.certificado_origen != undefined?
                                            (detalle.certificado_origen.toString()=='0'?'No funge como certificado de origen':
                                            'Si funge como certificado de origen')
                                            : ''
                                            }}</td>                                                                        
                                    <td>{{ detalle.numero_exp_aut }}</td>
                                </tr>
                            </table>

                            <!-- Datos Generales Emisor -->
                            <br/>
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Datos generales del emisor</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td>Tipo de identificador</td>
                                    <td colspan="2" >Tax ID/Sin Tax ID/RFC/CURP</td>
                                </tr>
                                
                                <tr>
                                    <td>
                                        {{ getTipoIdentificador(detalle.personas[0].tipo_identificador) }}
                                    </td>                                    
                                    <td colspan="2" >{{ detalle.personas[0].identificador }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td>Nombre(s) o Razón Social</td>
                                    <td>Apellido paterno</td>
                                    <td>Apellido materno</td>
                                </tr>
                                <tr>
                                    <td>{{ detalle.personas[0].nombres }}</td>
                                    <td>{{ detalle.personas[0].apellido_paterno }}</td>
                                    <td>{{ detalle.personas[0].apellido_materno }}</td>
                                </tr>
                                                                   
                            </table>

                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Domicilio del emisor</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td colspan="3" >Calle</td>
                                    <td>No. exterior</td>
                                    <td>No. interior</td>
                                    <td>Código postal</td>
                                </tr>
                                
                                <tr>
                                    <td colspan="3" >{{ detalle.personas[0].calle }}</td>
                                    <td>{{ detalle.personas[0].num_exterior }}</td>
                                    <td>{{ detalle.personas[0].num_interior }}</td>
                                    <td>{{ detalle.personas[0].codigo_postal }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Colonia</td>
                                    <td colspan="3" >Ciudad</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.personas[0].colonia }}</td>
                                    <td colspan="3" >{{ detalle.personas[0].ciudad }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Entidad federativa</td>
                                    <td colspan="3" >Municipio</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.personas[0].estado }}</td>
                                    <td colspan="3" >{{ detalle.personas[0].municipio }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="6" >País</td>
                                </tr>
                                <tr>
                                    <td colspan="6" >{{ getNombrePais(detalle.personas[0].pais) }}</td>
                                </tr>                               
                            </table>

                            <br/>                                                        
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Datos generales del destinatario</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >    
                                    <td>Tipo de identificador</td>
                                    <td colspan="2" >Tax ID/Sin Tax ID/RFC/CURP</td>
                                </tr>
                                
                                <tr>
                                    <td>
                                        {{ getTipoIdentificador(detalle.personas[1].tipo_identificador) }}
                                    </td>                                    
                                    <td colspan="2" >{{ detalle.personas[1].identificador }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td>Nombre(s) o Razón Social</td>
                                    <td>Apellido paterno</td>
                                    <td>Apellido materno</td>
                                </tr>
                                <tr>
                                    <td>{{ detalle.personas[1].nombres }}</td>
                                    <td>{{ detalle.personas[1].apellido_paterno }}</td>
                                    <td>{{ detalle.personas[1].apellido_materno }}</td>
                                </tr>
                                                                   
                            </table>

                            <br/>                            
                            <table border=0 width="100%" style="border:1px solid white !important;" >
                                <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                    <p style="font-weight: bold;" ><b>Domicilio del destinatario</b></p>
                                </td></tr>
                            </table>
                            <table>
                                <tr class="title-table" >
                                    <td colspan="3" >Calle</td>
                                    <td>No. exterior</td>
                                    <td>No. interior</td>
                                    <td>Código postal</td>
                                </tr>
                                
                                <tr>
                                    <td colspan="3" >{{ detalle.personas[1].calle }}</td>
                                    <td>{{ detalle.personas[1].num_exterior }}</td>
                                    <td>{{ detalle.personas[1].num_interior }}</td>
                                    <td>{{ detalle.personas[1].codigo_postal }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Colonia</td>
                                    <td colspan="3" >Ciudad</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.personas[1].colonia }}</td>
                                    <td colspan="3" >{{ detalle.personas[1].ciudad }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="3" >Entidad federativa</td>
                                    <td colspan="3" >Municipio</td>
                                </tr>
                                <tr>
                                    <td colspan="3" >{{ detalle.personas[1].estado }}</td>
                                    <td colspan="3" >{{ detalle.personas[1].municipio }}</td>
                                </tr>
                                <tr class="title-table" >
                                    <td colspan="6" >País</td>
                                </tr>
                                <tr>
                                    <td colspan="6" >{{ getNombrePais(detalle.personas[1].pais) }}</td>
                                </tr>                               
                               
                            </table>

                            <!-- Datos Mercancias -->
                            <span v-for="(datos_mercancia, indexMerca) in detalle.mercancias" :key="'mercancia'+indexMerca" >
                                <br>                                
                                <table border=0 width="100%" style="border:1px solid white !important;" >
                                    <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                        <p style="font-weight: bold;" ><b>Datos de la mercancía</b></p>
                                    </td></tr>
                                </table>
                                <table width="100%" >
                                    <tr class="title-table" >
                                        <td colspan="2" >Descripción genérica de la mercancía</td>
                                        <td>Clave UMC</td>
                                        <td>Cantidad UMC</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" >{{ datos_mercancia.descripcion }}</td>
                                        <td>{{ getDescripcion(datos_mercancia.clave_med_comer, unidadesMedida) }}</td>
                                        <td>{{ formatNumber(datos_mercancia.cantidad_comerc,3) }}</td>
                                    </tr>
                                    <tr class="title-table" >
                                        <td>Tipo moneda</td>
                                        <td>Valor unitario</td>
                                        <td>Valor total</td>
                                        <td>Valor total en dólares</td>
                                    </tr>
                                    <tr>
                                        <td>{{ getDescripcion(datos_mercancia.moneda, tiposMoneda) }}</td>
                                        <td>$ {{ formatNumber(datos_mercancia.valor_unitario,6) }}</td>
                                        <td>$ {{ formatNumber(datos_mercancia.valor_total,6) }}</td>
                                        <td>$ {{ formatNumber(datos_mercancia.valor_total_dolares,4) }}</td>
                                    </tr>
                                </table>
                                
                                <span v-if="datos_mercancia.datos.length>0" >
                                    <br/>
                                    <table border=0 width="100%" style="border:1px solid white !important;" >
                                        <tr style="border:1px solid white !important;" ><td style="border:1px solid white !important;" >
                                            <p style="font-weight: bold;" ><b>Descripción de la mercancía</b></p>
                                        </td></tr>
                                    </table>
                                    <table width="100%" >
                                        <tr class="title-table" >
                                            <td>Marca</td>
                                            <td>Modelo</td>
                                            <td>Submodelo</td>
                                            <td>No. serie</td>
                                        </tr>                                                                            
                                        <tr v-for="(descripcion, indexDes) in datos_mercancia.datos" :key="'descEsp'+indexDes" >
                                            <td>{{ descripcion.marca }}</td>
                                            <td>{{ descripcion.modelo }}</td>
                                            <td>{{ descripcion.submodelo }}</td>
                                            <td>{{ descripcion.numero_serie }}</td>                                            
                                        </tr>
                                        </table>                                                 
                                </span>                                                             
                            </span> <!-- For de mercancias-->                            

                        </span>                       
                </v-container>
            </v-card-text>                   
        </v-card>
    </v-dialog>

    <v-dialog v-model="modalFacturas" max-width="70%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modalFacturas = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Facturas</strong>
                    </span>
                </v-card>                            
            </v-card-title>     
            <v-card-text>
                
                <v-container>
                    <v-client-table :data="facturas_items" :columns="columns_facturas" :options="options_facturas" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <!--template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" open-on-hover v-if="(props.row.estatus == 'Creado' || props.row.estatus == 'Error' || props.row.filename != null)" >
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >
                                                <v-icon v-if="fab" >mdi-close</v-icon>
                                                <v-icon v-else>reorder</v-icon>
                                            </v-btn>
                                        </template>                                        
                                        <v-btn x-small fab dark color="purple" v-if="props.row.filename != null" @click.native="downloadFile(props.row.filename)" title="Layout Cargado" v-tippy>
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="red"  v-if="props.row.estatus == 'Creado'" @click.native="cargarDetalleFactura(props.row)" title="Vista Previa PDF" v-tippy>
                                            <v-icon>mdi-file-pdf-box</v-icon>
                                        </v-btn>                                        
                                        <v-btn x-small fab dark color="blue" v-if="(props.row.estatus == 'Creado' || props.row.estatus == 'Error')" @click.native="transmitir(props.row._id)" title="Transmitir DVC" v-tippy>
                                            <v-icon>send</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" v-if="props.row.estatus == 'Creado'" @click.native="deleteRegistro(props.row._id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template-->

                            </v-client-table>
                </v-container>
            </v-card-text>    
            <v-card-actions>
                <v-spacer></v-spacer>                                                
                <v-btn small outlined @click.native="modalFacturas = false" >
                    <v-icon>cancel</v-icon> Cerrar
                </v-btn>
            </v-card-actions>                           
        </v-card>
    </v-dialog>
        
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {"v-refresh-button": RefreshButton,},

    data: () => ({
        facturas_items:[],
        modalFacturas:false,
        array_files:[],
        archivos_adjuntos_nombres:"",
        nombresRfcConsulta: {},
        fab: false,
        file: "",
        ext_file: "",
        unidadesMedida:[],
        tiposMoneda:[],
        paises:[],
        modalPdfCove: false,
        idCoveVistaPrevia: "",
        detalle_factura: [],
        showImages:true,
        name: "datagrid",
        importData: [],
        nombre_proceso: "",
        modal: false,
        cliente: '',
        usuario: '',
        rfc: '',
        columns: [
            "nombre_proceso",
            "created_at",
            "created_by",
            "fecha_envio",
            "estatus",
            "error",
            "facturas",
            "actions"
        ],
        options: {
            filterable: [
                "nombre_proceso",
                "created_at",
                "created_by",
                "fecha_envio",
                "estatus",
                "error",
            ],
            sortable: [
                "nombre_proceso",
                "created_at",
                "created_by",
                "fecha_envio",
                "estatus",
                "error",
            ],

            headings: {
                "nombre_proceso":"Nombre Proceso",
                "created_at":"Fecha Creado",
                "created_by":"Usuario",
                "fecha_envio":"Fecha de Envío",
                "estatus":"Estatus",                
                "error":"Error",
                actions: "Operaciones",
            },
        },

        columns_facturas: [
            "numero_factura",
            "fecha_expedicion",
            "tipo_operacion",
            "descripcion",
            "monto",
        ],
        options_facturas: {
            filterable: [
                "numero_factura",
                "fecha_expedicion",
                "tipo_operacion",
                "descripcion",
                "monto",
            ],
            sortable: [
                "numero_factura",
                "fecha_expedicion",
                "tipo_operacion",
                "descripcion",
                "monto",
            ],

            headings: {
                "numero_factura":"Número Factura",
                "fecha_expedicion":"Fecha Expedición",
                "tipo_operacion":"Tipo Operación",
                "descripcion":"Descripción",
                "monto":"Monto",
            },            
        },

        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
        },

        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Vucem-Transmisión",
                disabled: true,
                to: ""
            },
            {
                text: "Nuevo Proceso DVC",
                disabled: true,
                to: ""
            }
        ],
        emisores: [],
        sellos: [],
        ws_password: '',

        registros: {
            selected: [],
            items: [0],
        },
        facturas: {
            items: [],
            camposexcel: {
                "no_factura": "no_factura",
                "no_operacion": "no_operacion",
                "nombre_cove": "nombre_cove",
                "partidas": "partidas",
                "estatus": "estatus",
                "error": "error",
                "errores": "errores",
            },
        },
        columnsFacturas: [
            "no_factura",
            "no_operacion",
            "nombre_cove",
            "partidas",
            "estatus",
            "error",
            "errores",
            "xml",
            "pdf",
            "acuse",
        ],
        optionsFacturas: {
            filterable: [
                "no_factura",
                "no_operacion",
                "nombre_cove",
                "partidas",
                "estatus",
                "error",
            ],
            sortable: [
                "no_factura",
                "no_operacion",
                "nombre_cove",
                "partidas",
                "estatus",
                "error",
            ],
            headings: {
                no_factura: "Factura",
                o_operacion: "No. Operación",
                nombre_cove: "DVC",
                partidas: "Partidas",
                estatus: "Estatus",
                error: "Error Transmisión",
                errores: "Error Recuperación",
                xml: "XML",
                pdf: "PDF",
                acuse: "Acuse",
            }
        },

        registro_seleccionado: '',

        headersExcel: [
            "tipo_operacion",
            "emisor",
            "destinatario",
            "patenteAduanal",
            "fecha_expedicion",
            "observaciones",
            "usuarios_consulta",
            "tipo_figura",
            "correo_electronico",
            "numero_factura",
            "relaciondeFacturas",
            "certificado_origen",
            "numero_exp_aut",
            "subdivision",
            "terminoFacturacion",
            "descuentos",
            "descripcion",
            "monto",

            "numeroPartida",
            "descripcionGenerica",
            "clave_med_comer",
            "moneda",
            "cantidad_comerc",
            "valor_unitario",
            "valor_total",
            "valor_total_dolares",
            "marca",
            "modelo",
            "submodelo",
            "numero_serie"
        ],
        equivalencias: {
            "tipo_operacion": "Tipo de Operación",
            "emisor": "Identificación Fiscal Emisor",
            "destinatario": "Identificación Fiscal Destinatario",
            "patenteAduanal": "Patente del Agente Aduanal",
            "tipo_figura": "Tipo de Figura",
            "observaciones": "Observaciones",
            "usuarios_consulta": "RFC Consulta",
            "correo_electronico": "Correo Electrónico",
            "numero_factura": "Número de Factura",
            "relaciondeFacturas": "Relación de Facturas",
            "certificado_origen": "Certificado Origen",
            "numero_exp_aut": "Número de Exportador Autorizado",
            "subdivision": "Subdivisión",
            "descuentos": "Descuentos",
            "descripcion": "Descripción",
            "monto": "Monto",

            "terminoFacturacion": "Término Facturación",
            "descripcionGenerica": "Descripción Genérica",
            "clave_med_comer": "Clave de la unidad de medida",
            "moneda": "Tipo de Moneda",
            "marca": "Marca",
            "modelo": "Modelo",
            "submodelo": "Sub-Modelo",
            "numero_serie": "Numero de Serie"
        },

        maxLen: {
            "tipo_operacion": 1,
            "emisor": 50,
            "destinatario": 50,
            "patenteAduanal": 4,
            "observaciones": 1000,
            "usuarios_consulta": 13,
            "tipo_figura": 1,
            "correo_electronico": 70,
            "numero_factura": 36,
            "relaciondeFacturas": 4,
            "certificado_origen": 1,
            "numero_exp_aut": 50,
            "subdivision": 1,
            "terminoFacturacion": 3,
            "descripcionGenerica": 256,
            "clave_med_comer": 30,
            "moneda": 3,            
        },

        camposObligatorios: {
            "tipo_operacion": "Tipo de Operación",
            "emisor": "Identificación Fiscal Emisor",
            "destinatario": "Identificación Fiscal Destinatario",
            "patenteAduanal": "Patente del Agente Aduanal",
            "fecha_expedicion": "Fecha de Expedición",
            "tipo_figura": "Tipo de Figura",
            "correo_electronico": "Correo Electrónico",
            "numero_factura": "Número de Factura",
            "relaciondeFacturas": "Relación de Facturas",
            "certificado_origen": "Certificado Origen",
            "subdivision": "Subdivisión",
            "descuentos": "Descuentos",
            "descripcion": "Descripción",
            "monto": "Monto",
            "numeroPartida": "Número de Partida",
            "descripcionGenerica": "Descripción Genérica",
            "clave_med_comer": "Clave de la unidad de medida",
            "moneda": "Tipo de Moneda",
            "cantidad_comerc": "Cantidad Comercial",
            "valor_unitario": "Valor Unitario",
            "valor_total": "Valor Total",
            "valor_total_dolares": "Valor en Dólares",

            "observaciones":"Observaciones",
            "usuarios_consulta":"RFC Consulta",
            "numero_exp_aut":"Número de Exportador Autorizado",
            "terminoFacturacion":"Término Facturación",
            "marca": "Marca",
            "modelo": "Modelo",
            "submodelo": "Sub-Modelo",
            "numero_serie": "Numero de Serie"
        },
    }),
     
    computed: {
        getNameExcel() {
            return "CovesTransmitidos" + this.rfc + ".xlsx";
        },
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.facturas.items;
            }

        },
    },

    methods: {
        pickFile() {
            this.$refs.file_input.click()
        },
        onFilePicked(e) {
            try {
                this.array_files = e.target.files; 

                for (const file of this.array_files) {
                    if (file !== undefined) {                        
                        this.archivos_adjuntos_nombres += file.name+", ";
                    }
                }                
                               
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }
        },
        reset: function() {
            const input = this.$refs.file_input;
            if (input != undefined) {
                input.type = 'text';
                input.type = 'file';
            }
            this.array_files = [];    
            this.archivos_adjuntos_nombres = "";
        },
        to_base64: function(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.addEventListener('load', () => {
                    var file = reader.result; // this is an image file that can be sent to server...          
                    var n = file.search("base64,");
                    //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
                    if (n >= 0) {
                        file = file.substring(n + 7);
                    }
                    resolve(file);                    
                });
                //reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        openModal: function (type) {
            this.modal = true;
        },
        getTipoIdentificador(idTipo){
            var tipo = idTipo.toString();
            if (tipo == "1")
                return "RFC";
            else if (tipo == "2")
                return "CURP";
            else if (tipo == "3")
                return "Sin Tax ID";
            else 
                return "Tax ID";
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                rfc: this.rfc
            };
            axios
                .post(this.URL + "listar/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.registros.items = res.data;
                        this.registros.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.created_at) - new Date(a.created_at) ;
                        });
                        for (var k in this.registros.items) {
                            this.registros.items[k].created_at = this.parseDate(this.registros.items[k].created_at);
                            this.registros.items[k].fecha_envio = this.parseDate(this.registros.items[k].fecha_envio);
                        }
                    }
                })
                .catch(err => {
                    
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        cargarFacturas: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: this.registro_seleccionado
            };
            axios
                .post(this.URL + "get_detalles_coves/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.facturas.items = res.data;
                        //LOS CAMPOS xml, pdf y acuse, tienen valores (0-Pendiente, 1-En cola, 2-Recuperado, 3-Error, 4-No recuperable)
                        for (var k in this.facturas.items) {
                            this.facturas.items[k].estatus = this.getEstatusDetalle(this.facturas.items[k].estatus);
                            if (this.facturas.items[k].errores != null) {
                                var errores_string = '';
                                var thisObject = this;
                                var err_array = this.facturas.items[k].errores.map(function (err) {
                                    return thisObject.parseDate(err.fecha) + ": " + err.error;
                                });
                                err_array.forEach(element => {
                                    errores_string += element + ", ";
                                });
                                this.facturas.items[k].errores = errores_string;
                            }
                        }

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los DVCs del registro seleccionado.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getEstatus: function (estatus) {
            var arr_estatus = ["Sin transmitir", "Transmitido correctamente", "Transmitido con errores", "Transmitiendo"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },

        getEstatusDetalle: function (estatus) {
            var arr_estatus = ["Pendiente", "Transmitido", "Aceptado", "Rechazado"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },

        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 > 2;
            var nombre = file.name.split(".")
            this.ext_file = nombre[nombre.length - 1];            
            this.file = file;

            if (isLt2M) {                
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "El archivo no debe ser mayor a 2MB.",
                    footer: ""
                });
                return false;                    
            }
            return true;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + this.camposObligatorios[key] + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        verificaMaxlen: function (results) {
            var errores = '';

            for (var key in this.maxLen) {
                if (key == "usuarios_consulta" && results[key] != null) {
                    var rfcs = results["usuarios_consulta"].split(",");
                    for (var r in rfcs) {
                        if (rfcs[r].toString().trim().length > this.maxLen[key]) {
                            errores += '<br/>' + "- El campo '" + this.equivalencias[key] + ":" + rfcs[r].toString().trim() +
                                "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
                        }
                    }
                } else {
                    if (results[key] != null && results[key].toString().trim().length > this.maxLen[key]) {
                        errores += '<br/>' + "- El campo '" + this.equivalencias[key] + ":" + results[key].toString().trim() +
                            "' no permite más de " + this.maxLen[key] + (this.maxLen[key] > 1 ? " caracteres/digitos." : " caracter/digito.");
                    }
                }

            }

            return errores == '' ? true : errores;
        },

        validaCorreo: function (mail) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(mail);
        },

        cargarEmisores: function () {
            var datos = {
                cliente: this.cliente
            };
            axios
                .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los emisores.",
                        footer: ""
                    });
                });
        },

        cargarCertificados: function () {
            var rfc = this.rfc;
            var datos = {
                cliente: this.cliente
            };
            axios
                .post(this.$hostname + "catalogos/certificados/list_certificados/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.sellos = res.data;
                        if (this.sellos.length > 0) {
                            var search = this.sellos.filter(function (e) {
                                return e.estatus == 1 && e.activo == true; //1-Sello correcto
                            });
                            if (search.length > 0) {
                                let sello = search[0];
                                this.ws_password = sello.clave_ws;
                            } else {
                                var search2 = this.sellos.filter(function (e) {
                                    return e.estatus == 0 && e.activo == true; //0-Sello sin probar
                                });
                                if (search2.length > 0) {
                                    let sello = search2[0];
                                    this.ws_password = sello.clave_ws;
                                } else {
                                    this.$swal({
                                        type: "warning",
                                        title: "Advertencia",
                                        text: "El cliente: " + rfc + " no tiene sellos digitales validados. Favor de verificar.",
                                        footer: ""
                                    });

                                }
                            }
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Advertencia",
                                text: "No se han configurado sellos digitales para el cliente: " + rfc,
                                footer: ""
                            });
                        }
                    }
                })
                .catch(err => {
                   
                });
        },

        verificaEmisor: function (emisor, opcion) {
            if (emisor == undefined)
                return false;

            var search = this.emisores.filter(function (e) {
                return e.rfc.toString().trim().toUpperCase() == emisor.toString().trim().toUpperCase();
            });
            if (opcion == 'domicilio')
                return search.length > 0 ? search[0] : '';
            else
                return search.length > 0;
        },

        cargarUnidadesMedida: function () {
            axios
                .post(this.$hostname + "catalogos/unidades_medida/lista/",{cliente:this.$local_storage.get("id_cliente")})
                .then(res => {                    
                    this.unidadesMedida = res.data;
                })
                .catch(err => {                   
                    console.log(err);
                });
        },
        cargarTiposMoneda: function () {
            axios
                .post(this.$hostname + "apendices/lista/",{tabla:10})
                .then(res => {                    
                    this.tiposMoneda = res.data;                    
                })
                .catch(err => {                   
                    console.log(err);
                });
        },
        cargarPaises: function () {
            axios
                .post(this.$hostname + "apendices/lista/",{tabla:17})
                .then(res => {                             
                    this.paises = res.data;                                        
                })
                .catch(err => {                   
                    console.log(err);
                });
        },

        getDescripcion: function(clave_in, arreglo){
            if (clave_in != null && clave_in.toString().trim()!="" && arreglo!=null && Array.isArray(arreglo)){
                var filter = arreglo.filter(function(e){
                    return e.clave.toString().trim().toUpperCase() == clave_in.toString().trim().toUpperCase();
                });
                if (filter.length>0){
                    return filter[0].descripcion;
                } 
            }
            return clave_in;            
        },
        getNombrePais: function(clave_in){
            if (clave_in != null && clave_in.toString().trim()!="" && this.paises!=null && Array.isArray(this.paises)){
                var filter = this.paises.filter(function(e){
                    return e.clave_m3.toString().trim().toUpperCase() == clave_in.toString().trim().toUpperCase();
                });
                if (filter.length>0){
                    return filter[0].nombre;
                } 
            }
            return clave_in;            
        },

        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else 
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },

        cargarAduanas: function () {
            axios
                .get(this.$hostname + "catalogos/aduanas/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.aduanas = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de aduanas",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                });
        },

        obtenerAduana(id_aduana) {
            let aduanas = this.aduanas.filter(function (e) {
                return e.id_aduana == id_aduana;
            });
            return aduanas.length > 0 ? (aduanas[0].clave + " - " + aduanas[0].nombre) : "N/A";
        },
        verificaAduana: function (aduana, opcion) {
            if (aduana == undefined)
                return false;

            var search = this.aduanas.filter(function (e) {
                return parseInt(e.clave.toString().trim()) == parseInt(aduana.toString().trim());
            });
            if (opcion == 'id')
                return search.length > 0 ? search[0].clave : '';
            else
                return search.length > 0;
        },

        //Validamos números Float con punto decimal y que cumpla con el número de decimales
        verificaDecimales: function (valor, numeroDecimales) {
            var cantidad_split = valor.toString().split(".");
            if (cantidad_split.length == 1) {
                if (Number.isNaN(parseInt(cantidad_split[0]))) {
                    return false;
                } else
                    return parseInt(cantidad_split[0]).toString() + "." + "0".repeat(numeroDecimales);
            } else if (cantidad_split.length == 2) {
                if (Number.isNaN(parseInt(cantidad_split[0])) || Number.isNaN(parseInt(cantidad_split[1]))) {
                    return false;
                } else if (cantidad_split[1].toString().length > numeroDecimales) {
                    var newNum = Math.round(valor * Math.pow(10, numeroDecimales)) / Math.pow(10, numeroDecimales);
                    return this.verificaDecimales(newNum, numeroDecimales);
                } else {
                    var repetir = numeroDecimales - cantidad_split[1].toString().length;
                    if (repetir == 0)
                        return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString();
                    else
                        return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString() + "0".repeat(repetir);

                }

            } else
                return false;
        },

        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            var rfc = thisObject.rfc;

            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información del 5to renglón en adelante.";
                } else {
                    for (var k in results) {
                        var obligatorios = thisObject.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {                            
                            var maxlen = thisObject.verificaMaxlen(results[k]);
                            if (maxlen !== true) {
                                errores++;
                                if (erroresText.indexOf(maxlen) == -1)
                                    erroresText += maxlen;
                            }

                            if (!Number.isInteger(results[k]["tipo_operacion"]) || (results[k]["tipo_operacion"] != 1 && results[k]["tipo_operacion"] != 2)) {
                                errores++;
                                errorTmp = "<br>- Tipo de Operación no válido: \"" + results[k]["tipo_operacion"] + "\", debe ser un número entero (1 o 2).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            if (rfc != results[k]["emisor"].toString().toUpperCase() && rfc != results[k]["destinatario"].toString().toUpperCase()) {
                                errores++;
                                errorTmp = "<br>- El RFC de la actual sesion: \"" + rfc + "\", debe fungir como emisor o destinatario forzosamente.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!thisObject.verificaEmisor(results[k]["emisor"])) {
                                errores++;
                                errorTmp = "<br>- El emisor: \"" + results[k]["emisor"] + "\", no existe en el catálogo de emisores/destinatarios.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            if (!thisObject.verificaEmisor(results[k]["destinatario"])) {
                                errores++;
                                errorTmp = "<br>- El destinatario: \"" + results[k]["destinatario"] + "\", no existe en el catálogo de emisores/destinatarios.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            var fechaOrig = results[k]["fecha_expedicion"];
                            results[k]["fecha_expedicion"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fecha_expedicion"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (results[k]["usuarios_consulta"] != null) {
                                if (results[k]["usuarios_consulta"].toString().trim() != ''){
                                    results[k]["usuarios_consulta"] = results[k]["usuarios_consulta"].toString().trim();
                                }else
                                    results[k]["usuarios_consulta"] = null;
                            }

                            if (!Number.isInteger(results[k]["tipo_figura"]) || (results[k]["tipo_figura"] != 4 && results[k]["tipo_figura"] != 5)) {
                                errores++;
                                errorTmp = "<br>- Tipo de Figura no válido: " + results[k]["tipo_figura"] + ", debe ser un número entero (4 o 5).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!thisObject.validaCorreo(results[k]["correo_electronico"])) {
                                errores++;
                                errorTmp = "<br>- El correo: " + results[k]["correo_electronico"] + ", no es válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["relaciondeFacturas"]) || (results[k]["relaciondeFacturas"] != 1 && results[k]["relaciondeFacturas"] != 2)) {
                                errores++;
                                errorTmp = "<br>- Relación de Facturas no válido: " + results[k]["relaciondeFacturas"] + ", debe ser un número entero (1 o 2).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["certificado_origen"]) || (results[k]["certificado_origen"] != 0 && results[k]["certificado_origen"] != 1)) {
                                errores++;
                                errorTmp = "<br>- Certificado Origen no válido: " + results[k]["certificado_origen"] + ", debe ser un número entero (0 o 1).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["subdivision"]) || (results[k]["subdivision"] != 0 && results[k]["subdivision"] != 1)) {
                                errores++;
                                errorTmp = "<br>- Subdivisión no válida: " + results[k]["subdivision"] + ", debe ser un número entero (0 o 1).";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["numeroPartida"])) {
                                errores++;
                                errorTmp = "<br>- Número de Partida no válido: " + results[k]["numeroPartida"] + ", debe ser un número entero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (!Number.isInteger(results[k]["moneda"])) {
                                errores++;
                                errorTmp = "<br>- Tipo de Moneda no válido: " + results[k]["moneda"] + ", debe ser un número entero del catalogo de Tipos de Moneda.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (thisObject.verificaDecimales(results[k]["monto"], 2) === false) {
                                errores++;
                                errorTmp = "<br>- Cantidad no válido: " + results[k]["monto"] + ", debe ser un número válido con 2 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["monto"] = thisObject.verificaDecimales(results[k]["monto"], 2);

                            if (thisObject.verificaDecimales(results[k]["cantidad_comerc"], 3) === false) {
                                errores++;
                                errorTmp = "<br>- Cantidad no válido: " + results[k]["cantidad_comerc"] + ", debe ser un número válido con 3 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["cantidad_comerc"] = thisObject.verificaDecimales(results[k]["cantidad_comerc"], 3);

                            if (thisObject.verificaDecimales(results[k]["valor_unitario"], 6) === false) {
                                errores++;
                                errorTmp = "<br>- Valor Unitario no válido: " + results[k]["valor_unitario"] + ", debe ser un número válido con 6 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["valor_unitario"] = thisObject.verificaDecimales(results[k]["valor_unitario"], 6);

                            if (thisObject.verificaDecimales(results[k]["valor_total"], 6) === false) {
                                errores++;
                                errorTmp = "<br>- Valor Total no válido: " + results[k]["valor_total"] + ", debe ser un número válido con 6 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["valor_total"] = thisObject.verificaDecimales(results[k]["valor_total"], 6);
                            //console.log(results[k]["valor_total"]);

                            if (thisObject.verificaDecimales(results[k]["valor_total_dolares"], 4) === false) {
                                errores++;
                                errorTmp = "<br>- Valor Dolares no válido: " + results[k]["valor_total_dolares"] + ", debe ser un número válido con 4 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["valor_total_dolares"] = thisObject.verificaDecimales(results[k]["valor_total_dolares"], 4);

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                //console.log(error);
                return ({
                    "errores": 1,
                    "erroresText": error.message
                });
            }

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';                      
            var facturas = [];           

            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                //console.log(header);
                //console.log(results);
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    const valoresIncorrectos = [null, undefined, '']
                    var partidasConError = []
                    var partidasTotal = [... new Set(results.map(x => x.numeroPartida + "__" + x.numero_factura))]
                    for (let i = 0; i < partidasTotal.length; i++) {
                        const [element, facturaStr] = partidasTotal[i].split("__");
                        var contadorNulos = 0

                        let partidasBuscadas = results.filter(x => x.numeroPartida == element && x.numero_factura == facturaStr)

                        if (partidasBuscadas.length > 1) {
                            partidasBuscadas.forEach( row => {
                                if(valoresIncorrectos.includes(row.marca) && valoresIncorrectos.includes(row.modelo) && valoresIncorrectos.includes(row.submodelo) && valoresIncorrectos.includes(row.numero_serie)) {
                                    contadorNulos += 1
                                }
                            });

                            if(contadorNulos > 1) partidasConError.push(element.toString())
                        }
                        
                    }

                    if(partidasConError.length > 0) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                            footer: "Partidas duplicadas sin descripciones especificas: No. Partida " + partidasConError.toString(),
                        });
                        this.$root.$dialogLoader.hide();
                        return
                    }

                    var resultadoFinal = [];
                    var desEspecific = {};
                    for (var k in results) {
                        var key_factura = results[k]["numero_factura"].toString().trim();
                        var numPartida = parseInt(results[k]["numeroPartida"].toString().trim())-1; //Le restamos 1, para que empiece de cero en adelante 

                        if (facturas[key_factura] == null)
                            facturas[key_factura] = {};

                        facturas[key_factura]["rfc_imp_exp"] = this.rfc;
                        
                        if (facturas[key_factura]["mercancias"] == null)
                            facturas[key_factura]["mercancias"] = [];
                        if (facturas[key_factura]["mercancias"][numPartida] == null)
                            facturas[key_factura]["mercancias"][numPartida] = {};

                        //if (results[k]["edocument"] != null)
                        //    facturas[key_factura]['edocument'] = results[k]["edocument"].toString();
                        facturas[key_factura]['tipo_operacion'] = parseInt(results[k]["tipo_operacion"].toString().trim());
                        facturas[key_factura]['patenteAduanal'] = results[k]["patenteAduanal"].toString().trim();
                        facturas[key_factura]['fecha_expedicion'] = results[k]["fecha_expedicion"].toString();
                        if (results[k]["observaciones"] != null)
                            facturas[key_factura]['observaciones'] = results[k]["observaciones"].toString();
                        
                        
                        if (results[k]["usuarios_consulta"] != null){                                                            
                            var rfcs = results[k]["usuarios_consulta"].toString().trim().split(",");
                            var rfc_consulta = [];
                            for(var krfc in rfcs){
                                rfc_consulta.push({"username":rfcs[krfc]})
                            }
                            facturas[key_factura]['usuarios_consulta'] = rfc_consulta;
                        }
                        
                        facturas[key_factura]['tipo_figura'] = results[k]["tipo_figura"].toString();
                        facturas[key_factura]['correo_electronico'] = results[k]["correo_electronico"];
                        facturas[key_factura]['numero_factura'] = key_factura;
                        
                        if (facturas[key_factura]['relacion_facturas'] == undefined)
                            facturas[key_factura]['relacion_facturas'] = results[k]["relaciondeFacturas"].toString();
                        
                        
                        facturas[key_factura]['certificado_origen'] = results[k]["certificado_origen"].toString();
                        facturas[key_factura]['numero_exp_aut'] = results[k]["numero_exp_aut"] != null ? results[k]["numero_exp_aut"].toString() : null;
                        facturas[key_factura]['subdivision'] = results[k]["subdivision"].toString();

                        facturas[key_factura]['descuentos'] = results[k]["descuentos"] != null ? results[k]["descuentos"].toString() : null;
                        facturas[key_factura]['descripcion'] = results[k]["descripcion"] != null ? results[k]["descripcion"].toString() : null;
                        facturas[key_factura]['monto'] = results[k]["monto"] != null ? results[k]["monto"].toString() : null;
                        
                        
                        if(!facturas[key_factura]['file_upload']){//Se agrgean los archivos solo una vez
                            facturas[key_factura]['file_upload'] = [];
                            for (const file of this.array_files) {
                                if (file !== undefined) {
                                    const contents = await this.to_base64(file);
                                    facturas[key_factura]['file_upload'].push({"file":contents});                                    
                                }
                                
                            }
                        }
                        

                        var emisor = await this.verificaEmisor(results[k]["emisor"], "domicilio");
                        facturas[key_factura]['personas'] = [];
                        var emisor_data = {
                            tipo_identificador: emisor.identificador!=null?emisor.identificador.clave.toString():"0",
                            identificador: emisor.rfc,
                            
                            apellido_paterno: "",
                            apellido_materno: "",
                            nombres: emisor.razon_social,
                            patente: facturas[key_factura]['patenteAduanal'],
                            identificador_persona: 1, //1-Proveedor
                            
                            calle: emisor.calle!=null?emisor.calle.toString():"",
                            num_exterior: emisor.numero_exterior!=null?emisor.numero_exterior.toString():"",
                            num_interior: emisor.numero_interior!=null?emisor.numero_interior.toString():"",
                            colonia: emisor.colonia!=null?emisor.colonia.toString():"",
                            ciudad: emisor.ciudad!=null?emisor.ciudad.toString():"",
                            municipio: emisor.municipio!=null?emisor.municipio.toString():"",
                            estado: emisor.estado_nombre!=null?emisor.estado_nombre.toString():"",
                            pais: emisor.pais!=null?emisor.pais.nombre.toString():"",
                            codigo_postal: emisor.codigo_postal!=null?emisor.codigo_postal.toString():"",
                            
                        };
                        facturas[key_factura]['personas'].push(emisor_data);
                        
                        var dest = await this.verificaEmisor(results[k]["destinatario"], "domicilio");
                        var destinatario_data = {
                            tipo_identificador: dest.identificador!=null?dest.identificador.clave.toString():"0",
                            identificador: dest.rfc,
                            
                            apellido_paterno: "",
                            apellido_materno: "",
                            nombres: dest.razon_social,
                            patente: facturas[key_factura]['patenteAduanal'],
                            identificador_persona: 2, //2-Destinatario
                            
                            calle: dest.calle!=null?dest.calle.toString():"",
                            num_exterior: dest.numero_exterior!=null?dest.numero_exterior.toString():"",
                            num_interior: dest.numero_interior!=null?dest.numero_interior.toString():"",
                            colonia: dest.colonia!=null?dest.colonia.toString():"",
                            ciudad: dest.ciudad!=null?dest.ciudad.toString():"",
                            municipio: dest.municipio!=null?dest.municipio.toString():"",
                            estado: dest.estado_nombre!=null?dest.estado_nombre.toString():"",
                            pais: dest.pais!=null?dest.pais.nombre.toString():"",
                            codigo_postal: dest.codigo_postal!=null?dest.codigo_postal.toString():"",
                            
                        };     
                        facturas[key_factura]['personas'].push(destinatario_data);                                          
                        
                        desEspecific = {};                              
                        if (results[k]["marca"] != null)
                            desEspecific["marca"] = results[k]["marca"].toString().substring(0,35);
                        if (results[k]["modelo"] != null)
                            desEspecific["modelo"] = results[k]["modelo"].toString().substring(0,50);
                        if (results[k]["submodelo"] != null)
                            desEspecific["submodelo"] = results[k]["submodelo"].toString().substring(0,50);
                        if (results[k]["numero_serie"] != null)
                            desEspecific["numero_serie"] = results[k]["numero_serie"].toString().substring(0,25);
                                                
                        if (facturas[key_factura]["mercancias"][numPartida]["datos"] != null){                            
                            if (Object.keys(desEspecific).length > 0)                                
                                facturas[key_factura]["mercancias"][numPartida]['datos'].push(desEspecific);
                        } else {
                            var descAuxiliar = [];
                            if (Object.keys(desEspecific).length > 0)                                
                                descAuxiliar.push(desEspecific)
                            facturas[key_factura]["mercancias"][numPartida] = {
                                descripcion: results[k]["descripcionGenerica"],
                                clave_med_comer: results[k]["clave_med_comer"].toString(),
                                moneda: results[k]["moneda"],
                                cantidad_comerc: results[k]["cantidad_comerc"].toString(),
                                valor_unitario: results[k]["valor_unitario"].toString(),
                                valor_total: results[k]["valor_total"].toString(),
                                valor_total_dolares: results[k]["valor_total_dolares"].toString(),
                                datos: descAuxiliar,
                            };                            
                        }
                        
                    } //for results
                    
                    
                    for (var k in facturas) {
                        resultadoFinal.push(facturas[k]);
                    }

                    //TODO: Subir el layout a S3
                    
                    let datos = {
                        rfc: this.rfc,
                        created_by: this.$local_storage.get("email"),
                        request: resultadoFinal,
                        nombre_proceso: this.nombre_proceso,
                    };

                    console.log(datos);
                    //this.$root.$dialogLoader.hide();
                    
                    axios
                        .post(this.URL + "crear/", datos)
                        .then(async response => {                            
                            
                            var thisObj = this;
                            var ext = ".xls";
                            if(thisObj.file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
                                ext = ".xlsx";
                            }

                            var keyBucket = this.rfc.toString().trim().toUpperCase() + "/transmision/" + response.data._id + "_LAYOUT_DVC_COVE"+ext;
                                    
                            var datoss3 = {
                                key: keyBucket,
                                bucket: "production.econnect.ds",
                                type: thisObj.file.type
                            }
                            
                            await axios.post(this.$hostname + 's3/upload_url/', datoss3)
                                .then(async res => {
                                    if (typeof res.data !== 'undefined') {
                                        var urlput = res.data.mensaje;
                                        //console.log(urlput);
                                        await axios.put(urlput, thisObj.file, {headers:{'Content-Type': thisObj.file.type}})
                                        .then((res) => {                                            
                                        }).catch((error)=>{
                                            console.log(error);                                            
                                        });                                        
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);                                                      
                                });

                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El layout se cargó correctamente. Puede transmitir el DVC cuando lo requiera.",
                                footer: ""
                            });                            
                        })
                        .catch(err => {
                            //console.log(err.response);
                            var errores = "";
                            if (err.response.data != undefined) {
                                if (err.response.data.mensaje != undefined) {
                                    if (typeof err.response.data.mensaje == "string")
                                        errores += err.response.data.mensaje;
                                    else
                                        errores += err.response.data.mensaje[0];

                                } else {
                                    Object.keys(err.response.data).forEach(function (key) {
                                        errores += key + ": " + err.response.data[key];
                                        errores += "<br>";
                                    });

                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.reset();
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },        

        transmitir: function (row_id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let datos = {
                _id: row_id,
                username: "DIJA88OO",
                password: "12345",
                enviado_por: this.$local_storage.get("email")         
            };
            axios
                .post(this.URL + "enviar/", datos)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Se ha iniciado el proceso de transmisión. Recibirá una notificación cuando el resultado esté disponible.",
                        footer: ""
                    });
                })
                .catch(err => {
                    //console.log(err.response);
                    var errores = "";
                    if (err.response.data != undefined) {
                        if (err.response.data.mensaje != undefined) {
                            if (typeof err.response.data.mensaje == "string")
                                errores += err.response.data.mensaje;
                            else
                                errores += err.response.data.mensaje[0];

                        } else {
                            Object.keys(err.response.data).forEach(function (key) {
                                errores += key + ": " + err.response.data[key];
                                errores += "<br>";
                            });

                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al intentar transmitir los DVCs.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },

        deleteRegistro: function (id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: id
            };
            axios.post(this.URL + "elimina_cove/", datos)
                .then(res => {

                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se eliminó correctamente.",
                        footer: ""
                    });

                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el registro.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadLayout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadFile: function(id, intento=1) {
            
            var key = this.rfc.toString().trim().toUpperCase() + "/transmision/" + id + "_LAYOUT_DVC_COVE.xlsx";
            if(intento == 2){
                key = this.rfc.toString().trim().toUpperCase() + "/transmision/" + id + "_LAYOUT_DVC_COVE.xls";
            }
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            let nombre_download = key.split("/").pop();
            
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    if(intento == 1){
                        this.downloadFile(id, 2);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }                    
                }
                }).catch((error) => {

                    if(intento == 1){
                        this.downloadFile(id, 2);
                    } else {
                        var mensaje = "Ocurrió un error al descargar el archivo";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                    }
                    
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadVistaPrevia: function(idCove, intento=0){            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..'); 
            var key = this.$local_storage.get("rfc")+"/coves/vista_previa/"+idCove.toString()+".pdf"
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }
            let nombre_download = key.split("/").pop();
            
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if (intento == 0){
                            this.generaVistaPrevia(idCove);                           
                        } else if(intento > 4) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar vista previa. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.downloadVistaPrevia(idCove, intento+1);
                        }
                        
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    
                    if (mensaje.indexOf("El archivo no existe en S3")!=-1 && intento<=4){
                        if (intento==0)
                            this.generaVistaPrevia(idCove);                            
                        else
                            this.downloadVistaPrevia(idCove, intento+1);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }                    
                });
            
        },
        generaVistaPrevia: function(idCove){                                          
            var datos = {
                id_documento: idCove,
                id_cliente: this.$local_storage.get("id_cliente"),
            };            
            axios.post(this.$hostname + "vucem/pdf_cove_preview/", datos)                                    
            .then(res => {
                this.downloadVistaPrevia(idCove, 1);
            })
            .catch(error => {
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined){
                    var mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    this.$root.$dialogLoader.hide();     
                } else {//Si es un timeout intentamos descargar el archivo
                    this.downloadVistaPrevia(idCove, 1);
                }                    
                console.log(error);
            });            
        },
        cargarDetalleFactura: function (row) {
            this.idCoveVistaPrevia = row._id;
                        
            this.detalle_factura = row.request;
            //this.nombresRfcConsulta = res.data.nombres;
            this.modalPdfCove = true;                
        },
        generaPDF(idHtml) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            var thisObj=this;   
            this.showImages = false;         

            var opt = {
                margin: [1.2, 0.5, 0.7, 0.70], //top, left, bottom, right
                filename: "DVC_Vista_Previa.pdf",
                image: {
                    type: "jpeg",
                    quality: 0.5
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: ["css", "legacy"] //"avoid-all",
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait",      
                    compress: true,                                 
                }
            };            

            
            var html = document.getElementById(idHtml);   
            html2pdf()
                .set(opt)                    
                .from(html)        
                .toPdf().get('pdf')
                .then(function(pdf){                    
                    var totalPages = pdf.internal.getNumberOfPages();

                    for (var i = 1; i <= totalPages; i++) {
                        var imagenH = document.getElementById("imageHeader");                        
                        pdf.setPage(i);                        
                        pdf.setFontSize(9);
                        //pdf.internal.pageSize.getWidth()  //Ancho de página
                        //pdf.internal.pageSize.getHeight()  //Alto de página
                        pdf.addImage(imagenH, "PNG", 0.5, 0.4, 2.0, .45);
                        pdf.text("__________________________________________________________________________________________________________", 
                            0.5, .95);
                        pdf.text("__________________________________________________________________________________________________________", 
                            0.5, pdf.internal.pageSize.getHeight() - 0.55);                                                
                        pdf.text(i +" / " + totalPages, 
                            pdf.internal.pageSize.getWidth() - .9, pdf.internal.pageSize.getHeight() - 0.4);
                    }                        
                        thisObj.showImages = true;
                        thisObj.$root.$dialogLoader.hide();                                                                 
                }).save();  
                       
        }, 

        verFacturas: function(row){
            this.facturas_items = [];
            for(var k in row.request){
                row.request[k].fecha_expedicion = this.parseDate(row.request[k].fecha_expedicion);                
                this.facturas_items.push(row.request[k]);
            }
            this.modalFacturas = true;
        },

    }, //methods

    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "anam-cove/";
        // this.URL = "http://localhost:8001/anam-cove/";
        this.cliente = this.$local_storage.get("id_cliente");
        this.usuario = this.$local_storage.get("id_usuario");
        this.rfc = this.$local_storage.get("rfc");
        this.cargarAduanas();
        this.cargarUnidadesMedida();
        this.cargarTiposMoneda();
        this.cargarPaises();
        this.cargarEmisores();
        this.cargarCertificados();
        this.cargar();
       
    }
};
</script>
<style scoped>
.manual > table > tr { page-break-inside: avoid }

.title-table {
    font-weight: bold !important;
    background-color: lightgray !important;
}

.manual > table {
    width: 100%;
    border-collapse: collapse;
}

.manual > table, td {
    padding-left: 2px;
    border: 1px solid #282828;
    height: 20px;
}
.titulo-principal {
    font-size: 1.1rem !important;
    font-weight: bold;
}
.manual {
    margin: 0px;
    padding: 0px;
    /*height: auto;
    width: auto; 
    background-color: #fff;*/
    text-align: justify;
    font-family: Arial;
    font-size: 0.90rem;
}
</style>